import { NumberInput } from '@components/NumberInput';
import { Label } from '@components/styled/Label.styled';
import { HandShakeIcon } from '@src/assets';
import React from 'react';
import { Chip } from './Chip';
import * as styled from './styled/MinStayGroup.styled';
import { TitleGroup } from './TitleGroup';

export const MinStayGroup: React.FC<{ disabled?: boolean }> = ({ disabled = false }) => {
    return (
        <styled.MinStayGroup>
            <TitleGroup
                title="Minimum stay requirements"
                Icon={HandShakeIcon}
                Chip={<Chip label="optional" variant="caution" />}
            />
            <div>
                If the property has a regulated minimum stay requirement, please indicate the
                required minimum amount of nights a guest must stay.
            </div>
            <styled.Wrapper>
                <NumberInput disabled={disabled} name="minMinStay" />
                <Label>minimum nights</Label>
            </styled.Wrapper>
        </styled.MinStayGroup>
    );
};
